import { hexToRGB } from './helper/tokenHelper';

export const spacings: { [key: string]: number | string } = {
  auto: 'auto',
  xxs: 4,
  xs: 8,
  sm: 12,
  md: 16,
  mdl: 20,
  lg: 24,
  xl: 32,
  xxl: 40,
  xxxl: 48,
  xxxxl: 56,
  sdxl: 62
};

export const radius = {
  default: 4,
  rounded: 50
};
/**
 * Please put any dark colors here
 */
export const DARK_COLORS = [
  'uiGreenTeal',
  'uiDirtyGreen',
  'uiLimeGreen',
  'uiOrangePrimary',
  'uiBlueCerulean',
  'uiBlue',
  'uiDarkPrimary',
  'uiBlueDark',
  'uiRedDarker',
  'uiBlurDarker',
  'uiGrayDarker'
];

export const colors = {
  // LIGHT
  uiGray: 'var(--uiGray)',
  uiGraySecondary: 'var(--uiGraySecondary)',
  uiGrayLighter: 'var(--uiGrayLighter)',
  uiGrayRaven: 'var(--uiGrayRaven)',
  uiLightPrimary: 'var(--uiLightPrimary)',
  uiLightSecondary: 'var(--uiLightSecondary)',
  uiOrangeYellow: 'var(--uiOrangeYellow)',
  uiYellow: 'var(--uiYellow)',
  uiBlueLight: 'var(--uiBlueLight)',
  uiLimeGreenLight: 'var(--uiLimeGreenLight)',
  // DARK
  uiGreenTeal: 'var(--uiGreenTeal)',
  uiDirtyGreen: 'var(--uiDirtyGreen)',
  uiLimeGreen: 'var(--uiLimeGreen)',
  // uiOrangePrimary: 'var(--uiOrangePrimary)',
  uiOrangePrimary: 'var(--uiOrangePrimary)',
  uiBlueCerulean: 'var(--uiBlueCerulean)',
  uiBlue: 'var(--uiBlue)',
  uiGrayDarker: 'var(--uiGrayDarker)',
  uiGrayWarmDark: 'var(--uiGrayWarmDark)',
  uiTealPrimary: 'var(--uiTealPrimary)',
  uiBlueLightPrimary: 'var(--uiBlueLightPrimary)',
  uiBluePrimary: 'var(--uiBluePrimary)',
  uiDarkPrimary: 'var(--uiDarkPrimary)',
  uiBlueDark: 'var(--uiBlueDark)',
  uiMidnight: 'var(--uiMidnight)',
  uiRedDarker: 'var(--uiRedDarker)',
  uiRedPrimary: 'var(--uiRedPrimary)',
  uiBlueDarker: 'var(--uiBlueDarker)',
  transparent: 'rgba(0,0,0,0)'
};

export const opacity = {
  opaque: 0.8,
  obscure: 0.65,
  translucent: 0.5,
  washedOut: 0.4,
  seeThrough: 0.2,
  clear: 0.15
};

export const elevationCss: { [key: string]: string } = {
  flat: 'none',
  container: `0 1px 2px ${hexToRGB(colors.uiDarkPrimary, opacity.seeThrough)}`,
  interactive: `0 2px 5px ${hexToRGB(colors.uiDarkPrimary, opacity.clear)}`,
  float: `0 4px 10px ${hexToRGB(colors.uiDarkPrimary, opacity.clear)}`,
  hover: `0 8px 16px ${hexToRGB(colors.uiDarkPrimary, opacity.seeThrough)}`
};
